import { combineReducers } from 'redux';
import { reducer as FormReducer } from 'redux-form';

import { UserReducer } from './UserReducer';
import { WorkoutsReducer } from './WorkoutsReducer';
import { ProfileReducer } from './ProfileReducer';
import { SearchUsersReducer } from './SearchUsersReducer';
import { LeaderboardsReducer } from './LeaderboardsReducer';
import { SearchWorkoutsReducer } from './SearchWorkoutsReducer';
import { MetaReducer } from './MetaReducer';
import { ClassesReducer } from './ClassesReducer';
import { ExercisesReducer } from './ExercisesReducer';
import { BookedUsersReducer } from './BookedUsersReducer';
import { MembershipPlansReducer } from './MembershipPlansReducer';
import { MembersReducer } from './MembersReducer';
import { GymTvReducer } from './GymTvReducer';
import { BreakdownReducer } from './BreakdownReducer';
import { ActivityReducer } from './ActivityReducer';

export default combineReducers({
    form: FormReducer,
    user: UserReducer,
    profile: ProfileReducer,
    activity: ActivityReducer,
    breakdown: BreakdownReducer,
    leaderboards: LeaderboardsReducer,
    workout: WorkoutsReducer,
    meta: MetaReducer,
    usersSearch: SearchUsersReducer,
    workoutsSearch: SearchWorkoutsReducer,
    classes: ClassesReducer,
    exercises: ExercisesReducer,
    usersBooked: BookedUsersReducer,
    membershipPlans: MembershipPlansReducer,
    members: MembersReducer,
    gymTv: GymTvReducer,
});



// WEBPACK FOOTER //
// ./src/Store/Reducers/index.js